<div class="flex flex-column h-full gap-4">
    <!-- Titre et introduction -->
    <div>
        @if (clients.length === 0 && !loading) {
        <p class="text-lg text-600">Vous n'avez pas encore d'organisation.</p>
        }
    </div>

    <!-- Conteneur scrollable pour la liste -->
    <div class="flex-grow-1 overflow-auto">
        <app-organizations-list [clients]="clients" [loading]="loading"
            (organizationSelected)="onOrganizationSelected($event)"></app-organizations-list>
    </div>

    <!-- Bouton d'ajout toujours visible en bas -->
    <div class="flex align-items-center justify-content-center pt-1">
        <p-button [rounded]="true" [raised]="true" label="Ajouter une nouvelle organisation"
            icon="pi pi-plus" (click)="onClickCreateOrganization()"></p-button>
    </div>
</div>
